import { Theme } from "@amx/ux-twoui-theming";
import { HighContrastSelector, ICalloutContentStyles } from "@fluentui/react";
import { INavLinkStyleProps, INavLinkStyles } from "@m365-admin/nav";
import { boxShadowDepths } from "../../../../styles/constants";

export const getLeftNavDirectLinkCalloutStyles = (theme: Theme): Partial<ICalloutContentStyles> => {
    return {
        calloutMain: { background: theme.palette.neutralHigh },
        beakCurtain: { background: theme.palette.neutralHigh },
        beak: { background: theme.palette.neutralHigh }
    };
};

export const getLeftNavDirectLinkStyles = (props: INavLinkStyleProps, theme: Theme, isNavCollapsed: boolean, isLastElement: boolean): Partial<INavLinkStyles> => {
    return {
        iconContainer: {
            "::before": {
                opacity: props.isSelected ? 1 : 0,
                backgroundColor: "#005FB8",
                width: "3px",
                height: "16px",
                left: "0px",
                borderRadius: "999px",
                [HighContrastSelector]: {
                    backgroundColor: "buttontext"
                }
            }
        },
        icon: {
            color: props.isSelected ? theme.palette.themeDarkAlt : theme.palette.neutralSecondary,
            display: "flex"
        },
        root: {
            marginLeft: isNavCollapsed ? undefined : "8px",
            marginRight: isNavCollapsed ? undefined : "8px",
            marginBottom: isLastElement ? undefined : "6px",
            borderRadius: "4px",
            minHeight: "40px",
            width: props.isNavCollapsed ? undefined : "220px",
            boxShadow: props.isSelected ? boxShadowDepths.rest : undefined,
            backgroundColor: props.isSelected ? theme.palette.neutralHigh : theme.palette.white,
            [HighContrastSelector]: {
                border: "1px solid windowtext",
                backgroundColor: props.isSelected ? "linkText" : undefined,
                "span": {
                    color: "buttontext"
                }
            },
            ":focus": {
                ":focus::after": {
                    borderRadius: "3px",
                    boxShadow: `0 0 0 1px ${theme.palette.neutralSecondary}`,
                    outline: "none",
                    border: "none",
                    [HighContrastSelector]: {
                        outline: "2px solid buttontext",
                        border: "1px solid buttontext"
                    }
                }
            },
            ":hover": {
                backgroundColor: theme.palette.neutralLighter,
                [HighContrastSelector]: {
                    backgroundColor: "highlight"
                }
            },
            ":active": {
                backgroundColor: theme.palette.neutralLight,
                "span": {
                    color: theme.palette.neutralSecondary
                }
            }
        }
    };
};
